<template>
    <div ref="pdfExportContainer">
        <slot></slot>
    </div>
</template>

<script>
    import { ref } from 'vue-demi';
    import useRouter from '../../../src/composables/use-router';
    import usePdf from '../../../src/composables/use-pdf';

    export default {
        name: 'PdfLayout',
        setup() {
            const router = useRouter().get();
            const pdfExportContainer = ref(null);

            const downloadPDF = async () => {
                await usePdf().download(pdfExportContainer.value);
                router.go();
            };

            return {
                pdfExportContainer,
                downloadPDF
            };
        }
    };
</script>
